import React from "react";
import { useBatchChangeVisibleToExternal } from "show/list/hooks/apis";
import BaseModal from "./BaseModal";
import { RadioGroup } from "components/Atoms/inputs/RadioGroup";

interface Props {
  mainArea: server.dto.MainAreas
  onClose: () => void
}

const ChangeVisibleToExternalModal = (props: Props) => {
  const [visibleToExternal, setVisibleToExternal] = React.useState<boolean>(true);
  const mutation = useBatchChangeVisibleToExternal(props.mainArea);

  const applyChanges = async () => mutation.mutateAsync(visibleToExternal);

  return <BaseModal
    mainArea={props.mainArea}
    action="change"
    onClose={props.onClose}
    title={RESX.GeneralLabels.VisibleToExternalUsers}
    hasSelectedValue={true}
    api={applyChanges}
  >
    <RadioGroup
      orientation="vertical"
      options={[{
        label: RESX.GeneralLabels.VisibleToExternalUsers,
        value: "yes"
      }, {
        label: RESX.GeneralLabels.NotVisibleToExternalUsers,
        value: "no"
      }]}
      value={visibleToExternal ? "yes" : "no"}
      onChange={v => setVisibleToExternal(v === "yes" ? true : false)}
    />
  </BaseModal>;
};

export default ChangeVisibleToExternalModal;